export enum SkillLevel {
    FAN = "Fan",
    BEGINNER = "Beginner",
    INTERMEDIATE = "Intermediate",
    ADVANCED = "Advanced",
    EXPERT = "Expert",
    ECLIPTIC = "Ecliptic",
}